import React, { useState, useCallback } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';

import Navigation from '../nav/index';
import Logo from '../../components/logo';
import Toggle from './toggle';
import Cta from './cta';

const Header = () => {
  const [menuIsOpen, setMenuOpen] = useState(false);
  const toggleMenuOpen = useCallback(() => setMenuOpen((state) => !state), []);
  return (
    <StyledHeader>
      <GlobalStyle menuIsOpen={menuIsOpen} />
      <Container>
        <InnerHeader>
          <Logo />
          <Navigation
            menuIsOpen={menuIsOpen}
            toggleMenuOpen={toggleMenuOpen}
          />

          <ToggleWrapper>
            <Cta />
            <Toggle $isOpen={menuIsOpen} onClick={toggleMenuOpen}>
              Menu
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                />
              </svg>
            </Toggle>
          </ToggleWrapper>
        </InnerHeader>
      </Container>
    </StyledHeader>
  );
};

const GlobalStyle = createGlobalStyle`
  body {
    overflow: ${(props) => (props.menuIsOpen ? 'hidden' : 'visible')};
  }
`;

const ToggleWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

const StyledHeader = styled.header`
  hyphens: none;
  background-color: ${(props) => props.theme.mainBackgroundColor};
  border-bottom: 1px solid ${(props) => props.theme.gray1};
  position: sticky;
  top: 0;
  z-index: 999;
`;

const InnerHeader = styled.div`
  min-height: 98px;
  display: flex;
  align-items: center;
`;

export default Header;
